import React from 'react';
import { PictureOutlined } from '@ant-design/icons';
import { Collapse, Space, Tag, Typography } from 'antd';
import { buildDesignUrl, closetStatusMeta } from '../utils';
import { openFromSelection } from 'src/utils/iframeNavigation';
import type { ClosetSnapshot } from '../types';

interface ClosetAccordionProps {
  closets: ClosetSnapshot[];
  projectIdForUnits: string;
  defaultOpen?: boolean;
}

export const ClosetAccordion: React.FC<ClosetAccordionProps> = ({
  closets,
  projectIdForUnits,
  defaultOpen,
}) => (
  <Collapse
    size='small'
    className='closet-accordion'
    expandIconPosition='end'
    defaultActiveKey={
      defaultOpen
        ? closets.map((c, idx) => (c.closet.id ?? c.closet.pk ?? `${idx}`))
        : undefined
    }
    items={closets.map((closetView, idx) => {
      const { closet, state, imageUrl } = closetView;
      const meta = closetStatusMeta[state];
      const closetIdentifier = closet.id ?? closet.pk;
      const panelKey = closetIdentifier ?? `${idx}`;
      const projectIdForCloset = closet.projectId ?? projectIdForUnits;
      const designUrl = buildDesignUrl(projectIdForCloset, closetIdentifier);
      const manualUrl = buildDesignUrl(projectIdForCloset, closetIdentifier, true);

      return {
        key: panelKey,
        label: (
          <div className='closet-accordion__header'>
            <Typography.Text strong>{closet.name || 'Closet'}</Typography.Text>
            <Space size={[6, 6]} wrap>
              <Tag color={meta.color} icon={meta.icon} className='project-panel__status-tag'>
                {meta.label}
              </Tag>
            </Space>
          </div>
        ),
        children: (
          <div className='closet-accordion__body'>
            <div className='closet-preview'>
              {imageUrl ? (
                designUrl ? (
                  <a href={designUrl} className='closet-preview__link' onClick={(event) => { event.preventDefault(); openFromSelection(designUrl); }}>
                    <img src={imageUrl} alt={closet.name ?? 'Closet preview'} />
                  </a>
                ) : (
                  <img src={imageUrl} alt={closet.name ?? 'Closet preview'} />
                )
              ) : (
                <div className='closet-preview__placeholder'>
                  <PictureOutlined />
                </div>
              )}
            </div>
            <Space direction='vertical' size={4} className='closet-actions'>
              {designUrl && (
                <a href={designUrl} className='closet-actions__link' onClick={(event) => { event.preventDefault(); openFromSelection(designUrl); }}>
                  Open Design
                </a>
              )}
              {manualUrl && (
                <a href={manualUrl} className='closet-actions__link' onClick={(event) => { event.preventDefault(); openFromSelection(manualUrl); }}>
                  Manual Auto Render
                </a>
              )}
            </Space>
          </div>
        ),
      };
    })}
  />
);
